// extracted by mini-css-extract-plugin
export default {"article":"ArticleText_article__SaqPG"};